<script setup lang="ts">
import { t } from "@/services/i18n";

defineProps({
    value: {
        type: String,
        default: "",
    },
    headline: {
        type: String,
        default: "",
    },
    defaultText: {
        type: String,
        default: "",
    },
    hasSearchButton: {
        type: Boolean,
        default: false,
    },
    isOpen: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["update:value", "onSubmit", "next", "reset"]);

function reset() {
    emit("reset");
}
</script>
<template>
    <div class="[ c-accordion ]">
        <div class="[ c-accordion__header ]">
            <span class="[ c-accordion__headline ]">{{ t(headline) }}</span>
            <span v-if="value">{{ t(value) }}</span>
            <span v-else>{{ t(defaultText) }}</span>
        </div>
        <div class="[ c-accordion__body ]">
            <div class="[ c-accordion__content-header ]">
                <h5>{{ t(headline) }}</h5>
                <span v-if="value && defaultText === t('sometime')">
                    {{ t(value) }}
                </span>
            </div>
            <div class="[ c-accordion__content ]">
                <slot></slot>
            </div>
            <div class="[ c-accordion__footer ]">
                <span
                    class="[ c-accordion__reset-button ]"
                    :class="{ 'c-accordion__reset-button--disabled': !value }"
                    @click="reset"
                >
                    {{ t("delete") }}
                </span>
                <button
                    v-if="hasSearchButton"
                    class="[ c-btn ] [ c-accordion__button ]"
                    @click="emit('onSubmit')"
                    type="submit"
                    aria-label="Search"
                >
                    <span>{{ t("search") }}</span>
                </button>
                <button
                    v-else
                    class="[ c-btn ] [ c-accordion__button c-accordion__button--secondary ]"
                    @click="emit('next')"
                    type="submit"
                    :aria-label="t('next')"
                >
                    <span>{{ t("next") }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
